export default __webpack_public_path__ + "static/media/S-010.1400aa94.png";